var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-edit-solid-16",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14,11 L1,13.8 C0.922054241,14.1362293 1.02300398,14.4888861 1.26705896,14.732941 C1.51111393,14.976996 1.86377073,15.0779458 2.2,15 L5,13.86 L12.32,6.54 L9.46,3.71 L2.14,11 Z M14.71,2.71 L13.29,1.29 C12.8999625,0.902276405 12.2700375,0.902276405 11.88,1.29 L11.17,2 L14,4.83 L14.71,4.12 C15.0977236,3.72996255 15.0977236,3.10003745 14.71,2.71 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.956aad8a10724adba41f9212c568caa9.svg";
export { ForwardRef as ReactComponent };